import { render, staticRenderFns } from "./panel-xs.vue?vue&type=template&id=2d9f0c6a"
import script from "./panel-xs.vue?vue&type=script&lang=js"
export * from "./panel-xs.vue?vue&type=script&lang=js"
import style0 from "./panel-xs.vue?vue&type=style&index=0&id=2d9f0c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports